import { PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';
import { Box, SxProps } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { Theme } from '@mui/material';

type UploadFilesWrapperProps = {
  sx?: SxProps<Theme>;
  uploadFiles: (files: File[]) => void;
};

function UploadFilesWrapper({
  children,
  sx,
  uploadFiles,
}: PropsWithChildren<UploadFilesWrapperProps>) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: true,
    noClick: true,
    noKeyboard: true,
    useFsAccessApi: false,
    onDrop: uploadFiles,
  });

  return (
    <UploadFilesContainer
      {...getRootProps()}
      sx={(theme) => ({
        ...(typeof sx === 'function' ? (sx as Function)?.(theme) : sx),
        ...(isDragActive && {
          borderColor: theme.palette.custom.link,
          backgroundColor: theme.palette.custom.mariner01,
          '& th': {
            backgroundColor: theme.palette.custom.mariner01,
            transition: '0s',
          },
        }),
      })}
    >
      <input {...getInputProps({ multiple: true, webkitdirectory: 'true' })} />
      {children}
    </UploadFilesContainer>
  );
}

const UploadFilesContainer = styled(Box, { label: 'UploadFilesContainer' })(({ theme }) => ({
  height: '100%',
  borderRadius: 4,
  transition: 'background-color 0.3s',
  border: '2px dashed transparent',
  padding: '0 24px',
}));

export default UploadFilesWrapper;
